export default commomImport => [{
  path: `mealpre-order`,
  name: 'mealpreOrder',
  meta: {
    title: ('store.mealPreOrder'),
    nameCount: 'preparings',
    noCache: true
  },
  //  全部订单
  component: commomImport('order-manager/meal-pre-order')
}];
